<template>
  <div>
    <Header />
    <Row v-for="payment in payments" :payment="payment" :key="payment.id"/>
  </div>
</template>
<script>
import Row from './Row';
import Header from './Header';

export default {
  components: {
    Header,
    Row,
  },
  computed: {
    payments() {
      return this.$store.payments.selected;
    },
  },
};
</script>
